import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight } from "lucide-react";

const WHATSAPP_URL = `https://wa.me/56999176009?text=${encodeURIComponent("Hola Carlos, me gustaría conversar sobre EOS para mi empresa.")}`;

export default function FinalCTA({
  eyebrow = "Próximo paso",
  title = <>¿Quieres saber si EOS es la forma de trabajo que{" "}<span className="text-[#F26522]">tu empresa necesita?</span></>,
  text = "Agenda una llamada introductoria -sin compromiso- y te cuento qué es EOS y cómo puede ayudar a tu empresa.",
  microcopy,
}) {
  return (
    <section
      id="contacto"
      data-testid="final-cta-section"
      className="section-padding bg-navy-800 text-white relative overflow-hidden"
    >
      {/* subtle pattern */}
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,1) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />
      {/* orange glow */}
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#F26522] opacity-10 blur-3xl pointer-events-none" />

      <div className="container-eos relative">
        <div className="max-w-3xl reveal">
          <span className="inline-block text-xs sm:text-sm font-bold tracking-[0.2em] uppercase text-[#F26522]">
            {eyebrow}
          </span>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-tight text-white">
            {title}
          </h2>
          <p className="mt-5 text-lg text-slate-300 leading-relaxed">
            {text}
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 reveal">
          <Link
            to="/contacto"
            data-testid="final-cta-button"
            className="btn-primary"
          >
            Agendar una llamada de 15 minutos
            <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-whatsapp-button"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white bg-white/5 backdrop-blur-sm font-semibold px-6 py-3 rounded-md transition-all duration-200 hover:bg-white/10 hover:border-white/60"
          >
            <MessageCircle className="w-4 h-4" />
            Escribir por WhatsApp
          </a>
        </div>
        {microcopy && <p className="mt-3 text-sm text-slate-400">{microcopy}</p>}
      </div>
    </section>
  );
}
